import { PageHeader } from '@/components'
import { FiscalNotesList } from './list/fiscal-note-list'
import {
  FiscalNotesListFilters,
  MIN_BORROWER_SEARCH_LENGTH,
} from './list/fiscal-note-list-filters'
import { getYear, getMonth } from 'date-fns'
import { useSearchParams } from 'react-router-dom'

const CURRENT_DATE = new Date()
const CURRENT_YEAR = getYear(CURRENT_DATE)

export function FiscalNotesPage() {
  const [searchParams] = useSearchParams()

  const selectedMonth =
    searchParams.get('m') || String(getMonth(CURRENT_DATE) + 1)

  const selectedYear = searchParams.get('y') || CURRENT_YEAR.toString()

  const borrowerSearch = searchParams.get('q')?.trim() ?? ''

  return (
    <>
      <PageHeader>Notas Fiscais</PageHeader>

      <FiscalNotesListFilters month={selectedMonth} year={selectedYear} />

      <FiscalNotesList
        month={selectedMonth}
        year={selectedYear}
        borrowerSearch={
          borrowerSearch.length >= MIN_BORROWER_SEARCH_LENGTH
            ? borrowerSearch
            : undefined
        }
      />
    </>
  )
}
